// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5e6cc5f","455":"e5132c60"}[chunkId] + ".chunk.js";
};